import { data } from 'react-router'
import { EventCard } from '#app/components/event-card.tsx'
import { type Route } from './+types/$eventSlug.ts'

export const meta: Route.MetaFunction = ({ data: loaderData }) => [
	{ title: loaderData ? `${loaderData.event.title} | EBHS` : 'Event | EBHS' },
]

export async function loader({ params }: Route.LoaderArgs) {
	const { getEventBySlug } = await import('#app/models/event.server.ts')
	const event = await getEventBySlug(params.eventSlug)
	if (!event || (!event.published && !event.archived)) {
		throw data({ error: 'Event not found' }, { status: 404 })
	}
	return data({ event })
}

export default function EventDetail({ loaderData }: Route.ComponentProps) {
	const { event } = loaderData

	return (
		<div className="px-4 pb-8 pt-4">
			<div className="mx-auto max-w-6xl text-lg sm:px-6 lg:px-8">
				<EventCard event={event} />
			</div>
		</div>
	)
}
